export const PARTNER_SEARCH_PARAM = 'partner';
export const CLOUD_ID_SEARCH_PARAM = 'cloud_id';
export const QR_SEARCH_PARAM = 'qr';
